// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/serving.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/serving-mobile.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/curtains.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/curtains-mobile.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/furniture.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../public/accessories.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog {
  padding: 0 6.875rem;
  cursor: pointer;
}
@media (max-width: 768px) {
  .catalog {
    padding: 0 1rem;
  }
}
.catalog__header {
  font-size: 2.5rem;
  font-weight: 600;
  line-height: 3.25rem;
  color: rgba(var(--orange));
}
@media (max-width: 768px) {
  .catalog__header {
    font-size: 1.75rem;
    line-height: 2rem;
  }
}
.catalog__content {
  display: grid;
  grid-template-columns: 1.35fr 1fr 1.65fr;
  grid-auto-rows: 14.625rem;
  grid-gap: 1.5rem;
  margin-top: 1.5rem;
}
@media (max-width: 768px) {
  .catalog__content {
    grid-auto-rows: 10.875rem;
    grid-gap: 1rem;
    grid-template-columns: 1fr;
  }
}
.catalog__content-serving {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  grid-column-start: 1;
  grid-row-start: 1;
  grid-row-end: 3;
}
@media (max-width: 768px) {
  .catalog__content-serving {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    grid-column-start: 1;
    grid-row-start: 1;
    grid-row-end: 2;
  }
}
.catalog__content-curtains {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  grid-column-start: 2;
  grid-row-start: 1;
  grid-row-end: 3;
}
@media (max-width: 768px) {
  .catalog__content-curtains {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    grid-column-start: 1;
    grid-row-start: 2;
    grid-row-end: 3;
  }
}
.catalog__content-furniture {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.catalog__content-accessories {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.catalog-img {
  font-family: var(--merriweather);
  display: flex;
  align-items: flex-end;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 0.75rem;
  font-weight: 300;
  font-size: 1.5rem;
  line-height: 1.25;
  color: rgba(var(--white));
  padding: 2rem;
}
@media (max-width: 768px) {
  .catalog-img {
    font-size: 1.25rem;
    line-height: 1.6;
    padding: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Catalog/styles.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,eAAA;AACF;AACE;EAJF;IAKI,eAAA;EAEF;AACF;AAAE;EACE,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,0BAAA;AAEJ;AAAI;EANF;IAOI,kBAAA;IACA,iBAAA;EAGJ;AACF;AAAE;EACE,aAAA;EACA,wCAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAEJ;AAAI;EAPF;IAQI,yBAAA;IACA,cAAA;IACA,0BAAA;EAGJ;AACF;AADI;EACE,yDAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AAGN;AADM;EANF;IAOI,yDAAA;IACA,oBAAA;IACA,iBAAA;IACA,eAAA;EAIN;AACF;AADI;EACE,yDAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;AAGN;AADM;EANF;IAOI,yDAAA;IACA,oBAAA;IACA,iBAAA;IACA,eAAA;EAIN;AACF;AADI;EACE,yDAAA;AAGN;AAAI;EACE,yDAAA;AAEN;;AAGA;EACE,gCAAA;EACA,aAAA;EACA,qBAAA;EACA,4BAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,aAAA;AAAF;AAEE;EAbF;IAcI,kBAAA;IACA,gBAAA;IACA,aAAA;EACF;AACF","sourcesContent":[".catalog {\n  padding: 0 6.875rem;\n  cursor: pointer;\n\n  @media (max-width: 768px) {\n    padding: 0 1rem;\n  }\n\n  &__header {\n    font-size: 2.5rem;\n    font-weight: 600;\n    line-height: 3.25rem;\n    color: rgba(var(--orange));\n\n    @media (max-width: 768px) {\n      font-size: 1.75rem;\n      line-height: 2rem;\n    }\n  }\n\n  &__content {\n    display: grid;\n    grid-template-columns: 1.35fr 1fr 1.65fr;\n    grid-auto-rows: 14.625rem;\n    grid-gap: 1.5rem;\n    margin-top: 1.5rem;\n\n    @media (max-width: 768px) {\n      grid-auto-rows: 10.875rem;\n      grid-gap: 1rem;\n      grid-template-columns: 1fr;\n    }\n\n    &-serving {\n      background-image: url('../../../public/serving.jpg');\n      grid-column-start: 1;\n      grid-row-start: 1;\n      grid-row-end: 3;\n\n      @media (max-width: 768px) {\n        background-image: url('../../../public/serving-mobile.jpg');\n        grid-column-start: 1;\n        grid-row-start: 1;\n        grid-row-end: 2;\n      }\n    }\n\n    &-curtains {\n      background-image: url('../../../public/curtains.jpg');\n      grid-column-start: 2;\n      grid-row-start: 1;\n      grid-row-end: 3;\n\n      @media (max-width: 768px) {\n        background-image: url('../../../public/curtains-mobile.jpg');\n        grid-column-start: 1;\n        grid-row-start: 2;\n        grid-row-end: 3;\n      }\n    }\n\n    &-furniture {\n      background-image: url('../../../public/furniture.jpg');\n    }\n\n    &-accessories {\n      background-image: url('../../../public/accessories.jpg');\n    }\n  }\n}\n\n.catalog-img {\n  font-family: var(--merriweather);\n  display: flex;\n  align-items: flex-end;\n  background-repeat: no-repeat;\n  background-size: cover;\n  border-radius: 0.75rem;\n  font-weight: 300;\n  font-size: 1.5rem;\n  line-height: 1.25;\n  color: rgba(var(--white));\n  padding: 2rem;\n\n  @media (max-width: 768px) {\n    font-size: 1.25rem;\n    line-height: 1.6;\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
